import React, { Component } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { BackTop } from "antd";
import { registerLabel, setLabels } from "./actions/labelActions";
import { setLanguage } from "./actions/profileActions";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "antd/dist/antd.css";

import { Provider } from "react-redux";
import store from "./store";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Landing from "./components/layout/Landing";

import Trademark from "./components/trademark/Trademark";
import Design from "./components/design/Design";
import Origin from "./components/origin/Origin";
import ViewData from "./components/view/ViewData";

import "./App.css";

store.dispatch(registerLabel());

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Navbar />
            <Route exact path="/" component={Landing} />
            <div className="" style={{ backgroundColor: "rgb(229,239,241)" }}>
              <Route exact path="/trademark" component={Trademark} />
              <Route exact path="/design" component={Design} />
              <Route exact path="/originname" component={Origin} />
              <Route exact path="/view" component={ViewData} />
            </div>
            <Footer />
            <BackTop />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
